<template>
  <div class="u-agg-box ed-project-box">
    <div class="ed-project-tabs">
<!--      <a :class="{ 'pt-current': searchType === 'gbccl' }" href="javascript:;"-->
<!--         @click="changeSearchType('gbccl')">高标仓</a>-->
      <tab-button-group
          :data="['高标仓']"
          @onChangeTab="changeTableValue"
      />

<!--      <a :class="{ 'pt-current': searchType === 'lk' }" href="javascript:;"-->
<!--         @click="changeSearchType('lk')">冷库</a>-->
    </div>
    <div style="margin-top: 10px">
      <el-button size="small" class="data-type" :class="{'data-type-active': isActive('project')}" @click="changeDataType('project')">项目数据</el-button>
      <el-button size="small" class="data-type" :class="{'data-type-active': isActive('city')}" @click="changeDataType('city')">城市数据</el-button>
    </div>

    <standard-project
        :visible="vStandardProject"
    />

<!--    <cold-project-->
<!--        :visible="vColdProject"-->
<!--    />-->

    <standard-city
        :visible="vStandardCity"
    />

<!--    <cold-city-->
<!--        :visible="vColdCity"-->
<!--    />-->
  </div>
</template>

<script setup>
import StandardProject from '@/view/dataExport/standardProject/project.vue';
import ColdProject from '@/view/dataExport/coldProject/project.vue';
import StandardCity from '@/view/dataExport/standardCity/city.vue';
import ColdCity from '@/view/dataExport/coldCity/city.vue';
import {computed, onMounted, ref} from "vue";
import TabButtonGroup from "@/components/tabButtonGroup.vue";
const GBC = 'gbccl';
const LK = 'lk';
const PROJECT = 'project';
const CITY = 'city';

// 分类类型
const searchType = ref(GBC);
// 表示数据类型
const dataType = ref(PROJECT)
const changeSearchType = (v) => {
  dataType.value = PROJECT;
  searchType.value = v;
}
const isActive = (v) => {
  return dataType.value === v
}
const changeDataType = (v) => {
  dataType.value = v;
}

const vStandardProject = computed(() => {
  return searchType.value === GBC && dataType.value === PROJECT;
})

const vColdProject = computed(() => {
  return searchType.value === LK && dataType.value === PROJECT;
})

const vStandardCity = computed(() => {
  return searchType.value === GBC && dataType.value === CITY;
})

const vColdCity = computed(() => {
  return searchType.value === LK && dataType.value === CITY;
})

const changeTableValue = () => {
  searchType.value = GBC;
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "./index.less";

.project{
  color: red;
}

.city{
  color: skyblue;
}
.data-type{
  font-size: 12px;
  margin-right: 20px;
  cursor: pointer;
  color: #999;
}
.data-type-active{
  color: #0A9BFC;
}
</style>